var _defs, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWayTosuccessFeedbackIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 476,
    viewBox: "0 0 75 476",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        font-size: 62.895px;\n        opacity: 0.36;\n        fill: #99449a;\n        font-family: Poppins;\n        font-weight: 500;\n      }\n    "))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "Feedback",
    className: "cls-1",
    transform: "translate(73.178 483.107) rotate(-90) scale(1.558)"
  }, "Feedback")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWayTosuccessFeedbackIcon2);
export default __webpack_public_path__ + "static/media/wayTosuccessFeedbackIcon2.068be13c74d437509b208716218e3942.svg";
export { ForwardRef as ReactComponent };